import { combineReducers } from 'redux'

const REDUX_ACTION_NAMESPACE = `__CRM`

const mergeReducers = reducers => ([{
  key: REDUX_ACTION_NAMESPACE,
  reducer: combineReducers(reducers)
}])

export {
  mergeReducers
}